import { Icon } from '@if/mui'
import { Box, Tooltip } from '@mui/material'
import { EOperationType } from '@src/types/loan/loan-operation'
import {
  Banknote,
  BanknoteArrowDown,
  BanknoteArrowUp,
  FileX,
  Handshake,
  Landmark,
  LucideIcon,
  PlaneLanding,
  PlaneTakeoff,
  Scale,
  Send,
  Undo2,
} from 'lucide-react'
import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

const DEFAULT_OPERATION_TYPE_ICON = Landmark

const OPERATION_TYPE_ICONS: Partial<Record<EOperationType, LucideIcon>> = {
  [EOperationType.CreateLoanOperation]: PlaneTakeoff,
  [EOperationType.ChangeOwnerOperation]: Handshake,
  [EOperationType.InvoiceOperation]: Banknote,
  [EOperationType.CustomerPaymentOperation]: BanknoteArrowDown,
  [EOperationType.ProductRefundOperation]: Undo2,
  [EOperationType.LenderPaymentOperation]: BanknoteArrowUp,
  [EOperationType.LoanClosingOperation]: PlaneLanding,
  [EOperationType.ClosingSettlementOperation]: Send,
  [EOperationType.ChargeOffOperation]: FileX,
  [EOperationType.LegacyBalanceNormalizationOperation]: Scale,
}

interface Props {
  operationType: EOperationType
}

export const OperationTypeIconComponent = ({ operationType }: Props): ReactNode => {
  const { t } = useTranslation()

  return (
    <Tooltip title={t(`enum.EOperationType.${operationType}`)}>
      <Box component="span" sx={{ display: 'inline-flex' }}>
        <Icon icon={OPERATION_TYPE_ICONS[operationType] ?? DEFAULT_OPERATION_TYPE_ICON} size="sm" color="action" />
      </Box>
    </Tooltip>
  )
}
